export default "/assets/images/alexa.dcba58b52700b14b.png";